import Landcover3ReviewSingle from "./pages/ReviewSingle";
import Landcover3ReviewSummary from "./pages/ReviewSummary";
import SummarySuperuser from "./pages/SummarySuperuser";
import Landcover3Task from "./pages/Task";

const routes = [
  { path: "task", element: Landcover3Task },
  { path: "review", element: Landcover3ReviewSummary },
  { path: "review/single", element: Landcover3ReviewSingle },
  { path: "superuser", element: SummarySuperuser },
];
export default routes;
